import React from "react";
import { IconButton, Badge } from "@mui/material";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";


const NotificationButton = ({ isDark }) => {
  return (
    <IconButton
      sx={{
        color: isDark ? "white" : "#9ca3af",
        padding: 1,
        borderRadius: 2,
        transition: "all 0.2s ease",
        "&:hover": {
          color: isDark ? "#d1d5db" : "#4b5563",
          backgroundColor: isDark ? "rgba(255, 255, 255, 0.1)" : "#f3f4f6",
        },
      }}
    >
      <Badge
        variant="dot"
        sx={{
          "& .MuiBadge-dot": {
            backgroundColor: "#1570EF",
            width: 12,
            height: 12,
            borderRadius: "50%",
            border: `2px solid ${isDark ? "#1f2937" : "white"}`,
            top: 4,
            right: 4,
          },
        }}
      >
        <NotificationsNoneOutlinedIcon
          sx={{
            fontSize: 20,
            color: isDark ? "white" : "black"
          }}
        />
      </Badge>
    </IconButton>
  );
};

export default NotificationButton;
